import {
  Button,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionExpiry } from '../model/useSessionExpiry';

/**
 * Предложение продлить сессию за минуту до её конца.
 * Показывается поверх текущей работы вошедшего пользователя и снимается
 * либо продлением, либо концом сессии.
 */
export const SessionExpiryDialog: FC = () => {
  const { t } = useTranslation('auth');
  const { isOfferShown, remainingSeconds, isExtending, extend } = useSessionExpiry();

  return (
    <DialogRoot open={isOfferShown} modal>
      <DialogContent
        showCloseButton={false}
        className="max-w-96"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{t('sessionExpiry.title')}</DialogTitle>
          <DialogDescription>{t('sessionExpiry.description')}</DialogDescription>
        </DialogHeader>
        <p className="text-sm font-medium text-foreground">
          {t('sessionExpiry.remaining', { count: remainingSeconds })}
        </p>
        <DialogFooter>
          <Button className="w-full" isLoading={isExtending} onClick={extend}>
            {t('sessionExpiry.extend')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
